import LoadingSpinner from 'components/Common/LoadingSpinner';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getCallTranscription } from 'store/calls/actions';
import CallTranscriptView from './Components/CallTranscriptView';
import useFeatureFlags from 'hooks/useFeatureFlags';
import { REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import { Container } from 'reactstrap';

function CallTranscription({is_prospect, lead_id}) {
  const { leads, loading, call_transcriptions, call_transcriptions_loading, prospects, prospects_loading } = useSelector(state => ({
    leads: state.Leads.leads,
    loading: state.Leads.loading,
    call_transcriptions: state.Calls.call_transcriptions,
    call_transcriptions_loading: state.Calls.call_transcriptions_loading,
    prospects: state.Prospects.leads,
    prospects_loading: state.Prospects.loading
  }));

  const dispatch = useDispatch();
  const [isFeatureFlagActive] = useFeatureFlags();

  useEffect(() => {
    const queryParams = {};
    if (is_prospect) {
      queryParams.product_type_id = 5
      queryParams.quote_call_id = prospects?.find(el => el.id ==lead_id)?.qf_quote_call?.id;
      !prospects_loading && dispatch(getCallTranscription({ queryParams }));
      return;
    }
    if (leads?.length) {
      queryParams.quote_call_id = leads[0]?.quote_call?.id;
      !loading && dispatch(getCallTranscription({ queryParams }));
    }
  }, [leads]);


  if (!call_transcriptions_loading && call_transcriptions?.data || isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_RANDOM_CALL_TRANSCRIPTIONS)) {
    return (
      <div>
        <CallTranscriptView call_data={is_prospect ? prospects : leads} call_transcriptions={call_transcriptions} />
      </div>
    )
  }
  return (
    <div className="page-content bg-white" id="page-content-wrapper">
    <Container className='d-flex align-items-center justify-content-center'>
      {call_transcriptions_loading ?
        <div>
          <LoadingSpinner />
        </div>
        :
        <h4>
          Transcription not available
        </h4>
      }
    </Container>
      </div>
  )
}

export default CallTranscription;